import React from "react";

const BUTTON_FIELDS = [
    { id: "add_to_cart", label: "Add to Cart" },
    { id: "buy_now", label: "Buy Now" },
    { id: "inquiry", label: "Inquiry" },
];

const ProductButtonOptions = ({ formData, onChange }) => {
    const handleToggle = (field, checked) => {
        onChange(field, checked);
    };

    return (
        <div className="oms-form-group">
            <label className="oms-form-label">Button</label>
            <div className="oms-checkbox-group">
                {BUTTON_FIELDS.map(({ id, label }) => (
                    <div className="oms-checkbox-item" key={id}>
                        <input
                            type="checkbox"
                            id={id}
                            checked={Boolean(formData[id])}
                            onChange={(e) => handleToggle(id, e.target.checked)}
                        />
                        <label htmlFor={id}>{label}</label>
                    </div>
                ))}
            </div>
            <p className="oms-form-hint" style={{ fontSize: "12px", color: "#666", marginTop: "6px" }}>
                Select which action buttons appear on the storefront for this product. You can enable multiple options.
            </p>
        </div>
    );
};

export default ProductButtonOptions;
